import { ensure } from "sprint-common-web";

import { ManzanitaPresetReference } from "../../../../../common/types/ManzanitaPresetReference";
import { FrameratePresets } from "../../../context/EncodeSpecificationItem";

interface createFrameratePresetsProps {
    framerateId23_976: string;
    framerateId24: string;
    framerateId25: string;
    framerateId29_97: string;
    framerateId30: string;
    framerateId50: string;
    framerateId59_94: string;
    framerateIdOther: string;
    framerateId60: string;
    manzanitaPresets: ManzanitaPresetReference[];
}
export const createFrameratePresets = ({
    framerateId23_976,
    framerateId24,
    framerateId25,
    framerateId29_97,
    framerateId30,
    framerateId50,
    framerateId59_94,
    framerateId60,
    framerateIdOther,
    manzanitaPresets
}: createFrameratePresetsProps): FrameratePresets => {
    return {
        "23.976": { id: framerateId23_976, name: getPresetName(manzanitaPresets, framerateId23_976) },
        "24": { id: framerateId24, name: getPresetName(manzanitaPresets, framerateId24) },
        "25": { id: framerateId25, name: getPresetName(manzanitaPresets, framerateId25) },
        "29.97": { id: framerateId29_97, name: getPresetName(manzanitaPresets, framerateId29_97) },
        "30": { id: framerateId30, name: getPresetName(manzanitaPresets, framerateId30) },
        "50": { id: framerateId50, name: getPresetName(manzanitaPresets, framerateId50) },
        "59.94": { id: framerateId59_94, name: getPresetName(manzanitaPresets, framerateId59_94) },
        "60": { id: framerateId60, name: getPresetName(manzanitaPresets, framerateId60) },
        OTHER: { id: framerateIdOther, name: getPresetName(manzanitaPresets, framerateIdOther) }
    };
};

const getPresetName = (manzanitaPresets: ManzanitaPresetReference[], manzanitaPresetId: string) => {
    const manzanitaPreset = manzanitaPresets.find((preset) => preset.id === manzanitaPresetId);

    ensure(manzanitaPreset);

    return manzanitaPreset.name;
};
